import React, { useState } from 'react';
import { NavLink } from 'redux-first-router-link';
import PropTypes from 'prop-types';
// import { InView } from 'react-intersection-observer';
import { getFileName } from '../../utils';
import { SITE_HOST } from '../../consts';

const ArticleCard = ({
  articles,
  hoverClass,
  isMobile,
  mobileBoxShadowClass,
  onClick,
}) => {
  const {
    hedUrl,
    headline,
    speciality,
    cardCopy,
    imageSrc,
    feature,
  } = articles;

  const [clicks, setClicks] = useState(0);

  let navUrl = hedUrl;
  if (!SITE_HOST.includes('-qa') && !SITE_HOST.includes('localhost')) {
    navUrl = `/better-off-with-an-ally/${hedUrl}`;
  }

  let processedCardCopy = cardCopy.replace(/&lt;/g, '<').replace(/&gt;/g, '>');

  const handleArticleCardClick = () => {
    const newCount = clicks + 1;
    setClicks(newCount);
  };

  // check that image flash doesn't keep happening after css updates are applied.
  // ON MOBILE: article cards are wrapped in NavLink tag -- on mobile we need to count clicks and on first click, change to "hover" state card, on second click, navigate to person's page
  return (
    <>
    {(imageSrc && isMobile && (clicks === 0))
      && <div className="article-card-minisite" onClick={handleArticleCardClick}>
        <div className="card-image-container">
          <div className="card-with-img">
            <img className="card-img" src={imageSrc} alt= {getFileName(imageSrc) } />
          </div>
        </div>
        <div className="card-info">
          <div className="subhead-grouping">
            <hr className="lander-hr-rule"></hr>
            <h3 className="card card-subhead">{speciality}</h3>
          </div>
          <h3 className="card card-headline">{headline}</h3>
        </div>
      </div>
    }

    {(imageSrc && isMobile && (clicks === 1))
      && <div className="article-card-minisite" onClick={handleArticleCardClick}>
        <div className="card-image-container">
          <NavLink to={navUrl}>
              <>
                <div className={`card-with-copy ${mobileBoxShadowClass}`}>
                  <div className="text-box">
                    <div className="feature">{feature}</div>
                  <div className="feature-copy" dangerouslySetInnerHTML={ { __html: processedCardCopy } }/>
                    <div className="read-more">Read More</div>
                  </div>
                </div>
              </>
          </NavLink>
        </div>
        <div className="card-info">
          <div className="subhead-grouping">
            <hr className="lander-hr-rule"></hr>
            <h3 className="card card-subhead">{speciality}</h3>
          </div>
          <h3 className="card card-headline">{headline}</h3>
        </div>
      </div>
    }

    {(imageSrc !== null && !isMobile) &&
      <div className="article-card-minisite">
        <div className="card-image-container">
          <NavLink to={navUrl}>
              <>
                {/* card with headshot */}
                <div className="card-with-img">
                  <img className="card-img" src={imageSrc} alt= {getFileName(imageSrc) } />
                </div>
                {/* on hover, card flips from img to card with copy */}
                <div className={`card-with-copy ${hoverClass}`}>
                  <div className="text-box">
                  {/* this will render a "Feature.01, cardCopy, and   Read More */}
                    <div className="feature">{feature}</div>
                  <div className="feature-copy" dangerouslySetInnerHTML={ { __html: processedCardCopy } }/>
                    <div className="read-more">Read More</div>
                  </div>
                </div>
              </>
          </NavLink>
        </div>
        <div className="card-info">
          <div className="subhead-grouping">
            <hr className="lander-hr-rule"></hr>
            <h3 className="card card-subhead">{speciality}</h3>
          </div>
          <h3 className="card card-headline">{headline}</h3>
        </div>
      </div>
    }
    
    {/* conditional rendering logic for Coming Soon article card, no hover, not clickable */}
    {(imageSrc === null) &&
      <div className="article-card-minisite">
            <div className="card-image-container">
                  <div className="coming-soon">
                    <div className="card-with-copy">
                      <div className="text-box">
                        <div className="feature">{feature}</div>
                        <div className="feature-copy" dangerouslySetInnerHTML={ { __html: processedCardCopy } }/>
                      </div>
                    </div>
                  </div>
            </div>
          </div>
    }
    </>
  );
};

ArticleCard.propTypes = {
  articles: PropTypes.object,
  className: PropTypes.string,
  isMobile: PropTypes.bool,
};

export default ArticleCard;
